export default {
  login_mfa: {
    title: '@:login.title',
    message: '등록한 전화번호의 SMS에\n인증 코드를 보냈습니다.',
    button_submit: '@:login.login',
    button_resend: '인증 코드 재발송하기',
    alert_success: '인증 코드를 재발송했습니다.',
    alert_error: '인증 코드의 재발송에 실패했습니다.',
    error: '@:common.error.code_9999',
    no_phone_number_message: '로그인한 이용자의 전화번호가 등록되지 않아 SMS 인증을 실시할 수 없습니다.\n\n귀사 계정 관리자에게 연락하여 전화번호 등록을 의뢰해 주세요.',
  },
}
